import { useContext } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import Clock from '~/icons/Clock';
import {
  RedWrapper,
  BadgeText,
  BlueWrapper,
  YellowWrapper,
  PurpleWrapper,
  WhiteWrapper
} from './Badges.styles';
import OnHoldTooltip from './OnHoldTooltip';

type OwnProps = Omit<React.HTMLProps<HTMLDivElement>, 'ref'>;

export const LockedBadge = (props: OwnProps) => (
  <RedWrapper {...props}>
    <BadgeText>Purchase in Progress</BadgeText>
  </RedWrapper>
);

export const PreOrderBadge = (props: OwnProps) => (
  <BlueWrapper {...props}>
    <BadgeText>Pre-Order Now</BadgeText>
  </BlueWrapper>
);

export const OnHoldBadge = ({
  showTooltip = true,
  ...rest
}: OwnProps & { showTooltip?: boolean }) => (
  <YellowWrapper {...rest}>
    {showTooltip ? <OnHoldTooltip /> : <BadgeText>On Hold</BadgeText>}
  </YellowWrapper>
);

export const RecentlyAddedBadge = (props: OwnProps) => (
  <PurpleWrapper {...props}>
    <BadgeText>Recently Added</BadgeText>
  </PurpleWrapper>
);

export function TimerBadge(props: OwnProps) {
  const { timeLeftAsShortString } = useContext(UnlockTimerContext);

  return (
    <WhiteWrapper {...props}>
      <BadgeText className="flex items-center gap-x-4 text-blue-6">
        <Clock />
        {timeLeftAsShortString}
      </BadgeText>
    </WhiteWrapper>
  );
}
